import { createContext, useContext } from 'react';

import type { TAuthActions } from '~context/auth/types';
import ClientLogger from '~logger/client';
import { LoggerMessages, LoggerServices } from '~logger/constants';
export const AuthContext = createContext<TAuthActions>({
	openRegister: () => undefined,
	openLogin: () => undefined,
});

export const useAuthActionsContext = () => {
	const context = useContext(AuthContext);
	if (!context) {
		ClientLogger.error(
			LoggerServices.UserService,
			LoggerMessages.AuthContextError,
			{}
		);
		throw Error('Auth context no context Provider');
	}
	return context;
};
